import './index.less';
import React from 'react';
import debounce from 'lodash/debounce';
import classnames from 'classnames';
import { Button } from '@tencent/dui/lib/components/Button';
import { isLogin } from '@tencent/docs-login';
import i18n from '@i18next/i18n';

import { network } from '@tencent/netcheck';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

/**
 * 本地文件转多人编辑走这里
 * 云编文件转多人编辑走 drive-file-convert
 * @returns
 */
const ConvertToOnlineButton = (): JSX.Element => {
    // 加一个 debounce，避免连续点击多次时，重复转多次
    const onClickConvertToOnline = debounce(async () => {
        if (!network.isOnline) return;
        // 未登录则唤起登录
        if (!isLogin()) {
            window.mqq.invoke('docx', 'switchAccount', { disallowedMethods: ['wework'] });
            return;
        }

        const syncManager = await SlideDataServices.SyncManager.promise();
        await syncManager.createDoc();
    }, 300, {
        leading: true,
        trailing: false,
    });

    return (
        <Button
            type="default"
            size="small"
            className={classnames('convert-to-online-btn', {
                'convert-to-online-btn-notOnline': !network.isOnline,
            })}
            onClick={onClickConvertToOnline}
        >
            {i18n.t('转多人编辑')}
        </Button>
    );
};

export default ConvertToOnlineButton;
